import React, { useState } from "react";
import "./contact.css";

import VendorForm from "../components/vendor-form";
import AttendeeForm from "../components/AttendeeForm";

const Contact = () => {
  const [role, setRole] = useState(null); // null | "vendor" | "attendee"

  return (
    <main className="contact-page">
      {/* Spacer for fixed nav + ticker */}

      <section className="contact-container">
        <div className="contact-forms">
          {role === null && (
            <div className="role-gate">
              <h1 className="role-gate-title">Which one are you?</h1>
              <p className="role-gate-subtitle">
                Pick an option to get the right form
              </p>

              <div className="role-gate-options">
                <button
                  type="button"
                  className="role-gate-card"
                  onClick={() => setRole("vendor")}
                >
                  <span className="role-gate-card-title">Vendor</span>
                  <span className="role-gate-card-desc">
                    I want to sell at a BizBaz event
                  </span>
                </button>

                <button
                  type="button"
                  className="role-gate-card"
                  onClick={() => setRole("attendee")}
                >
                  <span className="role-gate-card-title">Attendee</span>
                  <span className="role-gate-card-desc">
                    I want updates about upcoming events
                  </span>
                </button>
              </div>
            </div>
          )}

          {role !== null && (
            <div className="role-gate-back-wrap">
              <button
                type="button"
                className="role-gate-back"
                onClick={() => setRole(null)}
              >
                ← Back
              </button>
            </div>
          )}

          {role === "vendor" && <VendorForm />}
          {role === "attendee" && <AttendeeForm />}
        </div>
      </section>
    </main>
  );
};

export default Contact;